import { useState, useEffect } from "react";
import dayjs from "dayjs";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getEmployees } from "../../api/employee";
import { handleAxiosError } from "../../config/action-config";

const emptyActivityData = {
  id: "",
  bill_rate: "",
  task_id: "",
};
export default function UpdateEmployeeDialog({
  open,
  setOpen,
  lowestTasks,
  employees,
  projectId,
  selectedEmployee,
  onUpdate,
  projectType,
}) {
  const [data, setData] = useState(emptyActivityData);
  const [freeEmployees, setFreeEmployees] = useState([]);

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) setData(selectedEmployee);
  }, [open]);

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (!open) return;
    getEmployees({}, user.token)
      .then((res) => {
        const all = res.data.data;
        // const assignedIds = employees.map((e) => e.id);
        // setFreeEmployees(all.filter((e) => !assignedIds.includes(e.id)));
        setFreeEmployees(all);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen("UPDATE_EMPLOYEE");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Update</DialogTitle>
      <DialogContent>
        <Grid container minWidth={500} spacing={2} sx={{ pt: 2 }}>
          {lowestTasks.length ? (
            <>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Employee
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={data.id}
                    label="Employee"
                    name="id"
                    onChange={handleDataChange}
                  >
                    {freeEmployees.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label-task">
                    Task
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-task"
                    id="demo-simple-select-task"
                    value={data.task_id}
                    label="Task"
                    name="task_id"
                    onChange={handleDataChange}
                  >
                    {lowestTasks.map((t, i) => (
                      <MenuItem key={i} value={t.id}>
                        {t.task_code} - {t.task_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {projectType === "FIXED" || projectType === "SUBSCRIPTION" ? (
                <></>
              ) : (
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    margin="dense"
                    name="bill_rate"
                    fullWidth
                    value={data.bill_rate}
                    onChange={handleDataChange}
                    label="Bill Rate ($)"
                    type="number"
                    variant="outlined"
                  />
                </Grid>
              )}
            </>
          ) : (
            <Grid item xs={12} md={12}>
              <Typography
                color="red"
                sx={{ border: "1px solid red", borderRadius: "5px", p: 1 }}
              >
                Please create tasks for the project first.
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen("UPDATE_EMPLOYEE");
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onUpdate(getUpdatableEmployeeData(data));
          }}
          className="blue-button"
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function getUpdatableEmployeeData(data) {
  return {
    employee_id: data.id,
    bill_rate: data.bill_rate,
    task_id: data.task_id,
  };
}

function getLaterDate(d1, d2) {
  return dayjs(d1).isAfter(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}

function getEarlierDate(d1, d2) {
  return dayjs(d1).isBefore(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}
